import { useScrollReveal } from '../hooks/useScrollReveal';
import { useParallax } from '../hooks/useParallax';

export default function Section2Achievement({ forceVisible = false }: { forceVisible?: boolean }) {
  const { ref: titleRef, isVisible: titleVisible } = useScrollReveal(0.12, forceVisible);
  const { ref: orb1Ref, offset: orb1Y } = useParallax(0.06);
  const { ref: orb2Ref, offset: orb2Y } = useParallax(-0.05);

  return (
    <div className="relative min-h-screen flex flex-col justify-center overflow-hidden bg-background-50">
      {/* 三层背景光效 */}
      <div ref={orb1Ref} className="absolute top-32 right-20 w-[380px] h-[380px] rounded-full bg-primary-100/15 blur-[130px] pointer-events-none" style={{ transform: `translateY(${orb1Y}px)` }} />
      <div ref={orb2Ref} className="absolute bottom-24 left-16 w-[400px] h-[400px] rounded-full bg-accent-100/12 blur-[120px] pointer-events-none" style={{ transform: `translateY(${orb2Y}px)` }} />
      <div className="absolute top-1/2 right-1/3 w-[300px] h-[300px] rounded-full bg-secondary-100/8 blur-[160px] pointer-events-none animate-orb-float-2" />

      <div className="relative z-10 w-full max-w-[1400px] mx-auto px-6 md:px-10 lg:px-16 py-12 md:py-16">
        <div ref={titleRef} className="text-center mb-8 md:mb-10">
          <span
            className={`inline-block text-xs font-body font-semibold text-gold-600 uppercase tracking-[0.15em] mb-4 transition-all duration-700 ${
              titleVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-4'
            }`}
          >
            成果基础
          </span>
          <h2
            className={`font-heading text-3xl md:text-4xl lg:text-5xl font-bold text-foreground-950 mb-6 transition-all duration-1000 delay-100 ${
              titleVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'
            }`}
          >
            六年数据积累与<span className="bg-gradient-to-r from-primary-500 to-accent-500 bg-clip-text text-transparent">系统验证</span>
          </h2>
          <p
            className={`text-base md:text-lg text-foreground-950 font-body max-w-2xl mx-auto leading-relaxed transition-all duration-1000 delay-200 ${
              titleVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'
            }`}
          >
            起点并不是为了追赶技术潮流，而是传统人工评价走到一定规模后，客观上遇到了效率和一致性的瓶颈。先有人工评价的专业标准，再有大规模数据积累，再有模型训练和人机验证，最后才形成可以推广的AI评课系统。
          </p>
        </div>

        <div
          className={`transition-all duration-1000 delay-700 ${
            titleVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'
          }`}
        >
          <div className="p-6 md:p-8 rounded-2xl glass-liquid border border-primary-200/30">
            <div className="text-center mb-4">
              <span className="text-sm font-body text-accent-600 font-semibold uppercase tracking-wider"><span className="gold-dot mr-2" />发展逻辑</span>
            </div>
            <div className="flex flex-wrap items-center justify-center gap-2 md:gap-3">
              <span className="text-sm text-foreground-950 font-body px-4 py-2 rounded-xl glass-blue border-primary-200/30 font-medium">人工评价标准</span>
              <div className="flex items-center gap-1">
                <i className="ri-arrow-right-line text-gold-500 text-lg" />
              </div>
              <span className="text-sm text-foreground-950 font-body px-4 py-2 rounded-xl glass border-white/60 font-medium">数据积累</span>
              <div className="flex items-center gap-1">
                <i className="ri-arrow-right-line text-gold-500 text-lg" />
              </div>
              <span className="text-sm text-foreground-950 font-body px-4 py-2 rounded-xl glass border-white/60 font-medium">模型训练</span>
              <div className="flex items-center gap-1">
                <i className="ri-arrow-right-line text-gold-500 text-lg" />
              </div>
              <span className="text-sm font-body font-bold text-white px-5 py-2.5 rounded-xl gold-shimmer border-accent-200/40 shadow-sm">AI评课系统</span>
            </div>
            <p className="text-center text-xs text-foreground-950 font-body mt-4">* 最终数据以正式发布稿为准</p>
          </div>
        </div>
      </div>
    </div>
  );
}